/**
 * Utility function to fix S3 URL format
 * Converts regional S3 URLs to standard format for better CORS compatibility
 * @param url - The S3 URL to fix
 * @returns Fixed URL or undefined if no URL provided
 */
export const fixS3Url = (url: string | undefined): string | undefined => {
    if (!url) return undefined;

    // Check if it's an S3 URL with regional endpoint
    const s3RegionalPattern = /https:\/\/([^.]+)\.s3\.([^.]+)\.amazonaws\.com\/(.+)/;
    const match = url.match(s3RegionalPattern);

    if (match) {
        const bucketName = match[1];
        const path = match[3];

        // Convert to path-style URL (works better with CORS)
        return `https://${bucketName}.s3.amazonaws.com/${path}`;
    }

    return url;
};

/**
 * Get cache-busted image URL
 * @param url - The image URL
 * @param timestamp - Optional timestamp for cache busting
 * @returns URL with timestamp query parameter
 */
export const getCacheBustedImageUrl = (url: string | undefined, timestamp?: number): string | undefined => {
    if (!url) return undefined;

    const fixedUrl = fixS3Url(url);
    if (!fixedUrl) return undefined;

    const ts = timestamp || Date.now();
    return `${fixedUrl}?t=${ts}`;
};
